export default {
  getCarsIds: state => {
    return state.cars.items.map(car => car.id)
  }
}